/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { combineReducers } from 'redux';
import antiburnOsd from './antiburnosd/antiburnosd.reducers';
import appl from './appl/appl.reducers';
import channelOptionsOverlay from './overlay/channeloptionsoverlay/channeloptionsoverlay.reducers';
import errorOsd from './videoplayerui/osd/osd.reducers';
import enterChannelNumber from './guide/enterchannelnumber/enterchannelnumber.reducers';
import healthStats from './healthstats/systemhealthstats.reducers';
import gridGuide from './guide/guide.reducers';
import guideHighlight from './guide/guidehighlight/guidehighlight.reducers';
import infoBanner from './videoplayerui/infobanner/infobanner.reducers';
import inputFactory from './inputfactory/inputfactory.reducers';
import menulanguage from './settings/menulanguage/menulanguage.reducers';
import screens from './screens/screens.reducers';
import settings from './settings/settings.reducers';
import signin from './signin/signin.reducers';
import spinner from './spinner/spinner.reducers';
import turboScroll from './guide/turboscroll/turboscroll.reducers';
import urlChangeEvents from './urlchangeevents/urlchangeevents.reducers';
import videoDebugOverlay from './videoplayer/videodebugoverlay/videodebugoverlay.reducers';
import videoPlayer from './videoplayer/videoplayer.reducers';
import videoPlayerState from './videoplayer/videoplayerstate/videoplayerstate.reducers';
import visibilityEvents from './visibilityevents/visibilityevents.reducers';
import overlayHighlight from './overlay/overlayhighlight/overlayhighlight.reducers';
import whisper from './whisper/whisper.reducer';
import interactiveLayer from './interactivelayer/interactiveLayer.reducers';
import overlayDialog from './overlaydialog/overlaydialog.reducers';
import streamingRestriction from './videoplayer/streamingrestriction/streamingrestriction.reducers';
import settingsVideoWindow from './settings/settingsvideowindow/settingsvideowindow.reducers';

const RootReducer = combineReducers({
    antiburnOsd,
    appl,
    channelOptionsOverlay,
    errorOsd,
    enterChannelNumber,
    gridGuide,
    guideHighlight,
    healthStats,
    infoBanner,
    inputFactory,
    interactiveLayer,
    menulanguage,
    overlayDialog,
    overlayHighlight,
    screens,
    settings,
    settingsVideoWindow,
    signin,
    spinner,
    streamingRestriction,
    turboScroll,
    urlChangeEvents,
    videoDebugOverlay,
    videoPlayer,
    videoPlayerState,
    visibilityEvents,
    whisper,
});

export default RootReducer;

export type RootState = ReturnType<typeof RootReducer>;
